import {motion} from 'framer-motion';
import Card from '../../shared/Card';
import GeneralContext from '../../../context/GeneralContext';
import ButtonFunction from '../../shared/ButtonFunction';
import { useContext } from 'react';

function RestoreUser() {

    const { changeCurrentMenu, userResetData } = useContext(GeneralContext);

  return (
    <motion.div
        key='adminResetUser'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
        <Card hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'active-users'}>
            <h2>Restablecer a {userResetData.name}</h2>
            <ButtonFunction
            buttonFunction={changeCurrentMenu}
            buttonArguments={'reset-user-password'}
            buttonClass='adminButton'
        >
            Restablecer Contraseña
        </ButtonFunction>
        <br />
        <br />
        <ButtonFunction
            buttonFunction={changeCurrentMenu}
            buttonArguments={'reset-user-question'}
            buttonClass='adminButton'
        >
            Restablecer Pregunta de Seguridad
        </ButtonFunction>
        </Card>
    </motion.div>
  )
}

export default RestoreUser